"use strict";

var objToString = Object.prototype.toString, id = objToString.call(require("./noop"));

module.exports = function (value) {
	return typeof value === "function" && objToString.call(value) === id;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/function/is-function.js
// module id = 410
// module chunks = 54